import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSettings } from '../Settings';
import { LayoutDefault } from './default/LayoutDefault';
import { Page404 } from '../components/Page404';
import { PageConfig } from '../types';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from '../i18n';

const layoutMap: Record<string, React.ComponentType<{ page: PageConfig }>> = {
  default: LayoutDefault,
};

export function AppRoutes() {
  const { settings, loading, error } = useSettings();
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        flexDirection="column"
        gap={2}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          {t.layout.loading}
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        flexDirection="column"
        gap={2}
      >
        <Typography variant="h5" color="error">
          {t.layout.errorTitle}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Routes>
      {settings.pages.map((page) => {
        const LayoutComponent = layoutMap[page.layout] || LayoutDefault;
        return (
          <Route
            key={page.route}
            path={page.route}
            element={<LayoutComponent page={page} />}
          />
        );
      })}
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}
